import React from 'react';
import Header from './Header';
import Footer from './Footer';
import InitialLoader from './InitialLoader';
import StickyCTA from './StickyCTA';
import { SmoothScroll } from '../../motion/SmoothScroll';

const Layout = ({ children }) => {
  return (
    <SmoothScroll>
      <div id="ip-container" className="ip-container">
        <InitialLoader />
        <div id="container">
          <div id="top" />
          <Header />
          <div id="content">
            {children}
            <Footer />
          </div>
          <StickyCTA />
        </div>
      </div>
    </SmoothScroll>
  );
};

export default Layout;
